/* Keep the restock request usable when Klaviyo's timed discount popup opens.
 * These are the store's Klaviyo form IDs, not generated CSS class names.
 * Close through Klaviyo's own button so its focus trap and scroll lock clean up.
 */
(() => {
  const restockSelector = '[data-testid="klaviyo-form-Y5ETEG"]';
  const discountSelector = '[data-testid="klaviyo-form-RXvuBf"]';
  const closing = new WeakSet();
  let scheduled = false;

  function prioritizeRestock() {
    scheduled = false;
    const restock = document.querySelector(restockSelector);
    const restockDialog = restock?.closest('[role="dialog"]');
    if (!restockDialog || !restockDialog.getClientRects().length) return;

    const discount = document.querySelector(discountSelector);
    const discountDialog = discount?.closest('[role="dialog"]');
    const close = discountDialog?.querySelector('button[aria-label="Close dialog"]');
    if (!close || !discountDialog.getClientRects().length || closing.has(discountDialog)) return;

    closing.add(discountDialog);
    close.click();
    // The closing popup may return focus to its launcher behind the restock form.
    requestAnimationFrame(() => {
      if (restock.isConnected && !restockDialog.contains(document.activeElement)) {
        restock.querySelector('input[type="email"]')?.focus({ preventScroll: true });
      }
    });
  }

  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(prioritizeRestock);
  }).observe(document.body, { childList: true, subtree: true });
  prioritizeRestock();
})();
